import { RedirectRequest, SilentRequest } from '@azure/msal-browser';

import { CelumPropertiesProvider } from '@celum/core/configuration';

import { CustomDomainAuthFlowState } from '../services/auth.service';

/**
 * Adds relevant request options if the portal is on a custom domain.
 * In that case, we need to provide a custom redirect URI (logged-in-proxy) and add a state object with the original url and the redirect URI after login.
 * @returns a new request with the added information
 */
export function addCustomDomainStateToRequestIfNecessary<T extends RedirectRequest | SilentRequest>(request: T): T {
  if (!isCustomDomainRedirect(window.location.href)) {
    return request; // nothing to do if not a custom domain
  }

  const stateObject: CustomDomainAuthFlowState = {
    originatingWindowLocationHref: window.location.href,
    redirectUriAfterLogin: `${window.location.protocol}//${window.location.host}/logged-in`
  };

  const state = btoa(JSON.stringify(stateObject));

  return {
    ...request,
    redirectUri: `${CelumPropertiesProvider.properties.authentication.redirectUri}-proxy`,
    state
  };
}

function isCustomDomainRedirect(redirectUri: string): boolean {
  const normalRedirectUri = new URL(CelumPropertiesProvider.properties.authentication.redirectUri);
  const customRedirectUri = new URL(redirectUri);

  return customRedirectUri.host !== normalRedirectUri.host;
}
